import { GroupType } from "../models/GroupType";
import { GroupTypeQuery } from "../models/GroupTypeQuery";
import { BaseDataService } from "../../../../services/base/BaseDataService";

export class GroupTypeService extends BaseDataService<GroupType, GroupTypeQuery> {
  protected prefixUrl = `GroupTypes`;

}
